import { Modal } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FailedLogo } from '../../asset';
import PrimaryButton from '../button/PrimaryButton';

const NotifFailedSaved = ({ visible, message, action }) => {
  const { t } = useTranslation();

  return (
    <>
      <Modal
        visible={visible}
        closable={false}
        centered={true}
        width="414px"
        footer={null}
      >
        <div className="flex flex-col justify-center items-center gap-[9px] pt-6">
          <img src={FailedLogo} alt="fail" />
          <div className="flex flex-col justify-center items-center">
            <h2 className="font-roboto text-3xl font-bold mb-[16px]">
              Data Not Saved
            </h2>
            <p className="font-roboto text-[#666666] text-center mb-[16px] font-normal text-lg">
              {message}
            </p>
          </div>
        </div>
        <div className="content-center ml-4">
        <PrimaryButton
          text={t("COMMON:TRY_AGAIN")}
          action={action}
          styles="w-[334px] rounded-md"
        />
        </div>
      </Modal>
    </>
  );
};

export default NotifFailedSaved;